import { reatomAsync, withAbort, withDataAtom } from '@reatom/async';
import { atom } from '@reatom/framework';
import { BACKEND_API } from '@trwl/backend.api';

export const loadWishlistAction = reatomAsync(
  async (ctx, wishlistId: string) => {
    return BACKEND_API.WishlistApi.getWishlist(wishlistId, {
      signal: ctx.controller.signal,
    })
      .then((response) => response.data)
      .catch(() => null);
  },
).pipe(withDataAtom(null), withAbort());

export const getLastWishlistAction = reatomAsync(async (ctx) => {
  return BACKEND_API.WishlistApi.getLastWishlist({
    signal: ctx.controller.signal,
  })
    .then((response) => response.data)
    .catch(() => null);
}).pipe(withDataAtom(null), withAbort());

export const createWishlistAction = reatomAsync(async (ctx) => {
  return BACKEND_API.WishlistApi.createWishlist({
    signal: ctx.controller.signal,
  }).then((response) => response.data);
}).pipe(withDataAtom(null), withAbort());

export const createWishlistLoadingAtom = atom(
  (ctx) => ctx.spy(createWishlistAction.pendingAtom) > 0,
  'createWishlistLoadingAtom',
);
